// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iV","input":"iW","button":"iX"};